import React, { ChangeEvent, FC } from 'react';
import styled from 'styled-components';

const StyledDateSetting = styled.span`
  margin: 1rem 0.5rem 0 0;
`;

const StyledDateLabel = styled.label`
  margin: 0 0.2rem;
`;

const StyledRadioButton = styled.input`
  margin-left: auto;
`;

export const DateFormatRadio: FC<{
  id: string;
  name: string;
  value: any;
  changeHandler: (event: ChangeEvent<HTMLInputElement>) => void;
}> = ({ id, name, value, changeHandler }) => {
  return (
    <StyledDateSetting>
      <StyledRadioButton
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={localStorage.getItem('dateFormat') === value}
        onChange={changeHandler}
      />
      <StyledDateLabel htmlFor={id}>{value}</StyledDateLabel>
    </StyledDateSetting>
  );
};
